import React, { useState } from "react";
import sorentoBanner from "../assets/sorento.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Sorento = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "sorentoLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Kia Sorento",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={sorentoBanner} alt="Kia Sorento" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
      <section className="about-gravite">
        <h2>Experience the All-New Kia Sorento</h2>

        <p>
          The Kia Sorento is a premium three-row SUV launched in India with
          prices starting at ₹27.99 lakh and going up to ₹40.39 lakh
          (ex-showroom). Packed with intelligent performance options and
          cutting-edge technology, the Sorento features dual 12.3-inch curved
          displays, Kia AI Assistant with real-time generative AI capabilities,
          and a premium 12-speaker Bose sound system. Designed for versatile
          family luxury, it comes in flexible 6-seat and 7-seat layouts with
          ventilated seating in the first two rows and comprehensive Level-2
          ADAS protection.
        </p>
      </section>

      {/* TABLE */}
      <section className="tech-data">
        <h2>Technical Specifications of the Kia Sorento</h2>

        <table>
          <thead>
            <tr>
              <th>Specification</th>
              <th colSpan="4">Kia Sorento</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Expected Price Range</td>
              <td colSpan="4">₹27.99–40.39 Lakh (Ex-Showroom)</td>
            </tr>

            <tr>
              <td>Engine Options</td>
              <td colSpan="4">
                2.2L Turbo-Diesel / 1.6L Turbo-Petrol Strong Hybrid
              </td>
            </tr>

            <tr>
              <td>Transmission</td>
              <td colSpan="4">
                8-Speed DCT (Diesel) / 6-Speed Automatic (Hybrid)
              </td>
            </tr>

            <tr>
              <td>Power & Torque</td>
              <td colSpan="4">192 bhp & 442 Nm (2.2L Diesel)</td>
            </tr>

            <tr>
              <td>Drivetrain</td>
              <td colSpan="4">Front-Wheel Drive (FWD) / All-Wheel Drive (AWD)</td>
            </tr>

            <tr>
              <td>Seating Capacity</td>
              <td colSpan="4">6-Seater / 7-Seater Configurations</td>
            </tr>

            <tr>
              <td>Displays</td>
              <td colSpan="4">Dual 12.3-inch Curved Screens</td>
            </tr>

            <tr>
              <td>Smart Tech</td>
              <td colSpan="4">Kia AI Assistant (Generative AI)</td>
            </tr>

            <tr>
              <td>Audio System</td>
              <td colSpan="4">12-Speaker Bose Premium Sound System</td>
            </tr>

            <tr>
              <td>Comfort</td>
              <td colSpan="4">Ventilated Seats (1st & 2nd Rows)</td>
            </tr>

            <tr>
              <td>Safety</td>
              <td colSpan="4">10 Airbags, Level-2 ADAS, 360° Camera</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sorento;